<template>
  <div class="mt-3">
    <!-- <h1 class="font-bold" v-html="$t('pages.leagueFixtures.heading', { league: league?.name })" /> -->
    <PartialsGames :games="data?.games" />
  </div>
</template>

<script setup>
definePageMeta({
  layout: 'league'
})

const league = useLeagueStore()

const { data } = await useFetch(`/api/v1/leagues/${league.slug}/games`, { 
  key: `league-${league.slug}-fixtures`,
  baseURL: useEnv('apiBase'),
  query: {
    fromDate: useDate().format('YYYY-MM-DD'),
  }
})
</script>
